<template>
    <!-- <app-layout> -->

    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">


        <a name="identity" id="identity" class="pt-32"></a>
        <div class="md:grid md:grid-cols-3 md:gap-6">

            <div class="md:col-span-1">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-lg font-medium text-gray-900">
                        Identity
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        What name do you go by?
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 md:col-span-2 flex-col gap-y-8">
                <div class="bg-white shadow sm:rounded-md px-4 py-5 sm:p-6">
                    <identity :w_settings="widget_settings" :can_remove_branding="can_remove_branding" />
                </div>

            </div>

        </div>

        <jet-section-border />

        <a name="snippet" id="snippet" class="pt-32"></a>
        <div class="md:grid md:grid-cols-3 md:gap-6">

            <div class="md:col-span-1">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-lg font-medium text-gray-900">
                        Snippet
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        Install the Birdie snippet if you want to collect logs and/or hide sensitive data
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 md:col-span-2 flex-col gap-y-8">
                <div class="bg-white shadow sm:rounded-md px-4 py-5 sm:p-6">
                    <SnippetDetail :blur_snippet="blur_snippet" :has_installed_snippet="has_installed_snippet" />
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import Identity from '@/Components/Settings/Identity'
import SnippetDetail from '@/Components/Settings/SnippetDetail'

export default {
    props: ["widget_settings", "blur_snippet", "has_installed_snippet", "can_remove_branding"],
    components: {
        AppLayout, JetSectionBorder, Identity,
        SnippetDetail
    },
    layout: AppLayout, // keep layout in place avoid refreshing it
    data() {
        return {
            // team_slug: this.$page.props.user.current_team.slug,
            // team_name: this.$page.props.user.current_team.name,
            mockInterval: {}
        }
    },
    created() {
        // this.EventBus.on("start.call", function(toto) {
        //     this.test(toto)
        // }.bind(this));
        //console.log(this.notify_inapp_video_received)
    },
    beforeUnmount() {

    },
    mounted() {

        //const objet = { name: "Måske ønsker" }
        // const objet = { name: "宇佐見 惇 - Jun Usami" }
        //const objet = { name: "Gaëtan Eléanor" }
        // console.log("objet", objet);
        //const zep = btoa(JSON.stringify(objet));
        // const zep = btoa(unescape(encodeURIComponent(JSON.stringify(objet))));

        // let secure_zep = this.secureCode(zep);

        // console.log("zep", encodeURI(secure_zep));


        // if (this.hasNonASCIICharacters(objet.name)) {
        //     console.warn("Name contains non-ASCII characters:", objet.name);
        // } else {
        //     console.log("Name is ASCII-safe:", objet.name);
        // }

        // if (this.isUTF8SafeForBase64(objet.name)) {
        //     console.warn("Name is not safe for Base64 encoding:", objet.name);
        // } else {
        //     console.warn("Name is safe for Base64 encoding:", objet.name);
        // }

        // if (!this.testEncoding(objet.name)) {
        //     console.warn("Encoding test failed for:", objet.name);
        // } else {
        //     console.log("Encoding test passed for:", objet.name);
        // }


        // console.log("Home Mounted");

    },
    methods: {
        // secureCode: function (original) {
        //     let insert = "23nD35k";
        //     if (original.indexOf(insert) >= 0) {
        //         return original;
        //     }
        //     let randomPlace = Math.floor(Math.random() * (original.length - 1));
        //     return [original.slice(0, randomPlace), insert, original.slice(randomPlace)].join('');
        // },
        // hasNonASCIICharacters: function (str) {
        //     return /[^\x00-\x7F]/.test(str); // Matches any character outside the ASCII range
        // },
        // isUTF8SafeForBase64: function (str) {
        //     try {
        //         // Test if it can be safely encoded and decoded
        //         encodeURIComponent(str);
        //         return true;
        //     } catch (e) {
        //         return false;
        //     }
        // },
        // testEncoding: function (name) {
        //     try {
        //         const encoded = btoa(unescape(encodeURIComponent(name)));
        //         const decoded = decodeURIComponent(escape(atob(encoded)));
        //         return name === decoded; // True if encoding/decoding works as expected
        //     } catch (e) {
        //         return false; // An error indicates an issue with the name
        //     }
        // }

    }


}
</script>
